//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import COLOR from "utils/constants/color";

//  -- Features -----------------------
//  -- Thunks -------------------------
import SpinLoader from "components/Loader/SpinLoader";
import { handleGetPlacementOrgConfig, handleListPlacementexamForDistrict } from "store/placement_exam/thunks";
import PlacementExamDistrictList from "./PlacementExamDistrictList";
import { useCurrentUser } from "store/users/selectors";
import { usePlacementExamList } from "store/placement_exam/selectors";
import * as Sentry from '@sentry/react';
const MENU = [{ id: "placement_exam", value: "Placement exam" }];


const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
//   justify-content: space-between;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
//   border: 2px solid ${COLOR.black100};
//   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;
const MenuBtn = styled.button`
  background-color:white;
  border-top:none;
  border-left:none;
  border-right:none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  min-width: 150px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;

export default function PlacemetExamDistrict({}) {
  const location = useLocation();
  							  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataTab,] = useState("placement_exam");
  const [loading, setLoading] = useState(false);
  const placementExamList = usePlacementExamList()
  const currentUser= useCurrentUser();
  async function listExam(){
    setLoading(!placementExamList || placementExamList.length==0);
    try {
      await dispatch(handleListPlacementexamForDistrict(currentUser.orgId))
      await dispatch(handleGetPlacementOrgConfig(currentUser.orgId))
    } catch (error) {
      Sentry.captureException(`442 Error in listExam: ${error}`);
      console.error(error,"error in loading placement exam")
    } finally{
      setLoading(false);
    }
  }
  useEffect(()=>{
    if(currentUser&&currentUser.id){
        listExam()
    }
  },[currentUser])
  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch {
        navigate("/");
      } 
    }
    fetchData();
  }, []);
  return (
    <SentryWrap>
      <SpinLoader dataloader={loading} />
      <Wrapper className={"adminForm placemntExamTab"}>
        <MenuWrapper top={"10px"} style={{ width: "100%" }}>
          {MENU.map((x) => (
            <MenuBtn
              style={{
                borderBottom:
                  dataTab === x?.id
                    ? "5px solid rgb(28,49,115)"
                    : "5px solid #fcfcfc",
                color: dataTab === x?.id ? "rgb(28,49,115)" : "black",
              }}
              key={x.id}
              onClick={() => { }}
            >
              {x.value}
            </MenuBtn>
          ))}
        </MenuWrapper>
        <PlacementExamDistrictList
          userloading={loading}
        />
      </Wrapper>
    </SentryWrap>
  )
}
